import { isDesktop as e } from "../../utils/deviceUtils.js";
import t from "../../utils/classNames.js";
import { PLACEMENT as n } from "../../values/Placement.js";
import { TEXT_ALIGNMENT as r } from "../../values/TextAlignment.js";
import { forwardRef as i, useEffect as a, useState as o } from "react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/components/tooltip/Tooltip.tsx
var l = {
	STYLE_DEFAULT: "default",
	STYLE_ONBOARDING: "onboarding"
}, u = {
	TEXT_ALIGNMENT_LEFT: r.LEFT,
	TEXT_ALIGNMENT_CENTER: r.CENTER,
	TEXT_ALIGNMENT_RIGHT: r.RIGHT
}, d = i((n, r) => {
	let { allowOnTouch: i = !1, arrowProps: l, children: u, className: d = "", innerClassName: f = "", placement: p = "bottom", style: m, textAlignment: h = "center", tooltipStyle: g = "default", width: _ = "auto", ...v } = n, [y, b] = o(!1);
	if (a(() => b(!0), []), !e() && !i) return /* @__PURE__ */ s("span", { className: "display-none" });
	let x = t("tooltip", g && `tooltip-${g}`, p, "fade", y && "show", d), S = t("tooltip-inner", h && `text-${h}`, _ && `width-${_}`, f && f), C = { popover: "manual" };
	return /* @__PURE__ */ c("div", {
		"data-overlay-arrow-placement": p,
		...v,
		...C,
		role: "tooltip",
		ref: r,
		className: x,
		style: { ...m },
		children: [/* @__PURE__ */ s("div", {
			className: "tooltip-arrow",
			...l
		}), /* @__PURE__ */ s("div", {
			className: S,
			children: u
		})]
	});
});
Object.assign(d, l), Object.assign(d, n), Object.assign(d, u);
//#endregion
export { d as default };

//# sourceMappingURL=Tooltip.js.map